import { type CandidatesTranslations } from './candidates.translations.pl.ts';

export const candidatesTranslations: CandidatesTranslations = {
  columns: {
    areas: 'Domaines',
    candidate: 'Candidat',
    decisionDue: 'Décision avant le',
    quizFinished: 'Quiz terminé',
    score: 'Résultat',
    status: 'Statut',
    statusChanged: 'Dernier changement',
    studies: 'Université et lieu de stage',
  },
  filters: {
    area: 'Domaine',
    clear: 'Effacer les filtres',
    decisionFrom: 'Décision à partir du',
    decisionTo: "Décision jusqu'au",
    location: 'Lieu de stage',
    score: 'Appréciation du quiz',
  },
  noResults: 'Aucun candidat ne correspond aux critères',
  overdue: 'délai dépassé',
  profile: {
    about: 'À propos',
    activeTime: 'Temps passé dans le quiz',
    areas: "Domaines d'intérêt",
    categories: 'Résultats par catégorie',
    close: 'Fermer',
    fair: "Salon de l'emploi",
    fieldOfStudy: "Filière d'études",
    finished: 'Terminé',
    justification: 'Pourquoi ces domaines (selon le candidat)',
    language: 'Langue du candidat',
    loadError: 'Impossible de charger le profil du candidat.',
    location: 'Lieu de stage',
    minutes: '{{value}} min',
    no: 'non',
    noQuiz: "Le candidat n'a pas encore commencé le quiz.",
    points: 'Points',
    quiz: 'Quiz',
    registered: 'Inscription',
    skillLevels: ['ne connaît pas', 'débutant', 'élémentaire', 'bon', 'avancé'],
    skills: 'Auto-évaluation des compétences',
    skillTypes: {
      LANGUAGE: 'Langues',
      PROGRAMMING_LANGUAGE: 'Langages de programmation',
      SYSTEM_TECHNOLOGY_METHODOLOGY: 'Systèmes, technologies et méthodologies',
      TOOL: 'Outils',
    },
    started: 'Commencé',
    studentStatus: 'Statut',
    studies: 'Études',
    timeline: 'Historique du processus',
    typeOfStudy: "Type d'études",
    under30: 'Moins de 30 ans',
    university: 'Université',
    yearOfStudy: "Année d'études",
    yes: 'oui',
  },
  quickFilters: {
    afterQuiz: 'Après le quiz',
    all: 'Tous',
    fromFair: 'Issus des salons',
    inProgress: 'En cours',
    negative: 'Négatifs',
    onHold: 'En attente',
    positive: 'Positifs',
    stopped: 'Interrompus',
  },
  search: 'Rechercher par nom, e-mail ou téléphone',
  sortBy: 'Trier par : {{column}}',
  timeLeft: 'encore {{time}}',
  timelineEvents: {
    ACCOUNT_CREATION: 'Création du compte',
    ADMIN_DOWNLOAD_FULL_AUDIT: "L'administrateur a téléchargé l'audit complet",
    ADMIN_DOWNLOAD_PROCESS_DETAILS: "L'administrateur a téléchargé le dossier du processus",
    ADMIN_POSITIVE_FEEDBACK_CHANGE: "L'administrateur a changé la décision en positive",
    ADMIN_SET_NEGATIVE_FEEDBACK: "L'administrateur a fixé une décision négative",
    ADMIN_SET_ON_HOLD: "L'administrateur a mis la décision en attente",
    CANDIDATE_SENT_TO_ALL_EXTERNAL_RECRUITMENTS: 'Transmis à eRecruiter',
    EMAIL_SENT_ADMIN_FAIR_CANDIDATE_QUIZ_FINISHED: 'Notification aux administrateurs : candidat issu d’un salon',
    EMAIL_SENT_ADMIN_LOGIN: 'E-mail de connexion au panneau',
    EMAIL_SENT_ADMIN_ON_HOLD_REMINDER: 'Notification aux administrateurs : rappel de mise en attente',
    EMAIL_SENT_CANDIDATE_BACK_TO_APP_ACTIVE_PROCESS_NOT_ON_QUIZ: "E-mail : retour dans l'application",
    EMAIL_SENT_CANDIDATE_BACK_TO_APP_QUIZ_EXPIRED: 'E-mail : temps du quiz écoulé',
    EMAIL_SENT_CANDIDATE_BACK_TO_QUIZ: 'E-mail : retour au quiz',
    EMAIL_SENT_CANDIDATE_END_OF_PROCESS: 'E-mail : candidature reçue',
    EMAIL_SENT_CANDIDATE_LACK_OF_ACTIVITY: "E-mail : rappel d'inactivité",
    EMAIL_SENT_CANDIDATE_NOT_ACTIVE_PROCESS_FEEDBACK_SENT: 'E-mail : processus terminé',
    EMAIL_SENT_CANDIDATE_NOT_ACTIVE_PROCESS_WAITING_FOR_FEEDBACK: 'E-mail : en attente de la décision',
    EMAIL_SENT_CANDIDATE_ON_HOLD_NEEDS_MORE_TIME: 'E-mail : nous avons besoin de plus de temps',
    EMAIL_SENT_CANDIDATE_ONBOARDING: 'E-mail de bienvenue',
    EMAIL_SENT_NEGATIVE_FEEDBACK: 'E-mail de retour négatif',
    EMAIL_SENT_POSITIVE_FEEDBACK: 'E-mail de retour positif',
    other: 'Événement',
    PERSONAL_DATA_WITH_AREA_OF_INTEREST_SUBMISSION: "Données personnelles et domaines d'intérêt envoyés",
    PERSONAL_DATA_WITH_AREA_OF_INTEREST_UPDATE: "Données personnelles et domaines d'intérêt modifiés",
    QUIZ_FINISHED: 'Quiz terminé',
    QUIZ_INITIALIZATION: 'Quiz commencé',
    QUIZ_SUBMISSION: 'Quiz envoyé',
    SKILLS_ASSESSMENT_SUBMISSION: 'Compétences auto-évaluées',
    USER_LOGGED_IN: 'Connexion',
  },
  title: 'Candidats',
};
